"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/VGFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_246)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_246`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-7.91992 6.10352e-05H28.0801V24.0003H-7.91992V6.10352e-05Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.0801 6.10352e-05V8.24955H6.84087L10.0801 10.4096V11.9998H8.48906L3.33009 8.56019V11.9998H-1.16992V8.56019L-6.32889 11.9998H-7.91992V10.4096L-4.68069 8.24955H-7.91992V3.74955H-4.68069L-7.91992 1.59032V6.10352e-05H-6.32889L-1.16992 3.43884V6.10352e-05H3.33009V3.43884L8.48906 6.10352e-05H10.0801Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.20509 -0.000213623H-0.0449142V4.87477H-7.91992V7.12477H-0.0449142V11.9998H2.20509V7.12477H10.0801V4.87477H2.20509V-0.000213623Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-7.91992 -0.000274658V1.06025L-3.8856 3.74978H-2.29492L-7.91992 -0.000274658ZM10.0801 -0.000274658V1.06025L6.04577 3.74978H4.45509L10.0801 -0.000274658Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.08 1.59033V3.74977H6.84082L10.08 1.59033Z",
					fill: "#2E52B2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-7.91992 -0.000274658V1.06025L-3.8856 3.74978H-2.29492L-7.91992 -0.000274658ZM10.0801 -0.000274658V1.06025L6.04577 3.74978H4.45509L10.0801 -0.000274658Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.08 1.59033V3.74977H6.84082L10.08 1.59033Z",
					fill: "#2E52B2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-7.91992 11.9998V10.9394L-3.8856 8.24979H-2.29492L-7.91992 11.9998ZM10.0801 11.9998V10.9394L6.04577 8.24979H4.45509L10.0801 11.9998Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.0801 12.2606L15.8367 15.5041C16.4445 16.6765 17.6684 17.478 19.0801 17.478C20.4919 17.478 21.7157 16.6765 22.3236 15.5041L19.0801 12.2606Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.428 6.52155V12.2607C15.428 15.0563 19.0802 15.9128 19.0802 15.9128C19.0802 15.9128 22.7323 15.0563 22.7323 12.2607V6.52155H15.428Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18.2976 9.12994H19.8628V13.3036H18.2976V9.12994Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.0802 9.91254C19.5124 9.91254 19.8628 9.56217 19.8628 9.12996C19.8628 8.69775 19.5124 8.34738 19.0802 8.34738C18.648 8.34738 18.2976 8.69775 18.2976 9.12996C18.2976 9.56217 18.648 9.91254 19.0802 9.91254Z",
					fill: "#A2001D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.4717 7.56473H17.5151V8.60817H16.4717V7.56473ZM16.4717 9.9126H17.5151V10.956H16.4717V9.9126ZM16.4717 12.2604H17.5151V13.3039H16.4717V12.2604ZM20.6454 7.56473H21.6888V8.60817H20.6454V7.56473ZM20.6454 9.9126H21.6888V10.956H20.6454V9.9126ZM20.6454 12.2604H21.6888V13.3039H20.6454V12.2604Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_246`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as VGFlag };
